<template>
	<div class="myTemplate">
		<!-- 筛选 -->
		<filter-panel
			style="width: 100%"
			:data="group"
			:hideResult="true"
			@search="filterChange"
		></filter-panel>

		<!-- 列表 -->
		<data-list
			:table-style="{ name: 'mixture' }"
			:data="data"
			:hint="hint"
			:btnList="btnList"
			:columns="columns"
			:page="page"
			:loading="loading"
			@page-size-changed="pageSizeChanged"
			@page-changed="pageChanged"
		></data-list>

		<!-- 模版新增表单 -->
		<addTemplateForm ref="addTemplateForm" dialogWidth="600px" title="报告模板"></addTemplateForm>
	</div>
</template>

<script>
import listPageCreate from '@/mixins/listPageCreate';
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue';
import addTemplateForm from './form/addTemplateForm.vue';
import userSearch from '@/components/tools/userSearch';

import googleads from '@/backend/services/googleAds/googleAds.js';
import api from '@/backend/apiConfig/apiConfig';

const page = listPageCreate({
	searchConfig: {
		api: api.googleAds.getTemplateList,
		method: 'POST',
	},
});

export default {
	name: 'myTemplate',
	components: {
		filterPanel,
		addTemplateForm,
	},
	mixins: [page],
	computed: {
		addPermission: function (self) {
			return self.getPermission('templateAdd');
		},
		editPermission: function (self) {
			return self.getPermission('templateEdit');
		},
		deletePermission: function (self) {
			return self.getPermission('templateDelete');
		},
	},
	data() {
		let self = this;
		return {
			hint: {
				content: '注意：系统模板可供所有人使用',
				style: {
					fontSize: '14px',
					color: '#EC808D',
					marginLeft: '15px',
				},
			},
			btnList: [
				{
					name: '新增系统模板',
					position: 'right',
					showBtn: () => {
						return self.addPermission;
					},
					attribute: {
						loading: false,
					},
					async btnClick() {
						let { cancel } = await self.$refs.addTemplateForm.show({
							type: 2,
						});
						if (!cancel) {
							self.query();
						}
					},
				},
				{
					name: '新增个人模板',
					position: 'right',
					attribute: {
						type: 'primary',
						loading: false,
					},
					async btnClick() {
						let { cancel } = await self.$refs.addTemplateForm.show({
							type: 1,
						});
						if (!cancel) {
							self.query();
						}
					},
				},
			],
			columns: [
				{
					label: '模板类型',
					bind: val => {
						let { type } = val;
						switch (type - 0) {
							case 1:
								return '个人模板';
							case 2:
								return '系统模板';
						}
						return '-';
					},
				},
				{
					label: '模板名称',
					bind: 'name',
					type: 'preview',
					iconName: 'bianji',
					dataStyle: {
						'justify-content': 'flex-start',
					},
					preview: async row => {
						let data = await self.getTemplateDetails(row);
						let { cancel } = await self.$refs.addTemplateForm.show(data);
						if (!cancel) {
							self.query();
						}
					},
				},
				{
					label: '创建人',
					bind: 'createName',
				},
				{
					label: '创建时间',
					bind: 'createTime',
				},
				{
					label: '最后修改时间',
					bind: 'modifiedTime',
				},
				{
					label: '使用中的有效服务单数',
					bind: 'serviceEfficTotal',
				},
				{
					label: '累计生成周报',
					bind: 'weekReportTotal',
				},
				{
					label: '累计生成月报',
					bind: 'monthlyReportTotal',
				},
				{
					label: '累计生成自定义报告',
					bind: 'customizeReportTotal',
				},
				{
					label: '操作',
					type: 'btnClick',
					style: 'text',
					bind: () => {
						return [
							{
								text: '编辑',
								showButton(row) {
									let { type } = row;
									if (type === 1) return true;
									return self.editPermission;
								},
								trigger: async row => {
									let { id } = row;
									self.$router.push({
										name: 'templateEditor',
										query: {
											id,
										},
									});
								},
							},
							{
								text: '预览',
								trigger: async row => {
									let data = await self.getTemplateDetails(row);
									this.$router.push({
										name: 'reportPreviewSuggestions',
										params: data,
										query: {
											isTemplate: true,
										},
									});
								},
							},
							{
								text: '删除',
								showButton(row) {
									let { type } = row;
									if (type === 1) return true;
									return self.deletePermission;
								},
								trigger: async row => {
									try {
										let { id, serviceEfficTotal } = row;
										if (serviceEfficTotal === 0) {
											let control = await self.$confirmShow('确认删除？', '提示', {
												confirmButtonText: '确定',
												cancelButtonText: '取消',
											});
											if (control) {
												await googleads.deleteReportTemplate(id);
												self.$message.success('删除成功');
												self.query();
											}
										} else {
											await self.$confirmShow('使用中的模板不能删除', '提示', {
												confirmButtonText: '确定',
												showCancelButton: false,
											});
										}
									} catch (error) {
										console.log(error);
										self.$message.error('删除失败');
									}
								},
							},
						];
					},
				},
			],
			group: {
				others: [
					{
						tagName: 'sky-select',
						placeholder: '模板类型',
						label: '模板类型',
						value: '',
						prop: 'type',
						options: [
							{
								value: 1,
								label: '个人模板',
							},
							{
								value: 2,
								label: '系统模板',
							},
						],
					},
					{
						tagName: userSearch,
						placeholder: '创建人',
						label: '创建人',
						prop: 'creater',
						value: '',
					},
				],
			},
		};
	},
	mounted() {
		this.query();
	},
	methods: {
		async getTemplateDetails(row) {
			let { id } = row;
			let { data } = await googleads.getTemplateDetail({ id });
			return data;
		},
	},
};
</script>
